export const TIPOS_ETIQUETA = {
  desayuno: 'Desayuno',
  comida: 'Comida',
  cena: 'Cena',
  snack: 'Snack',
  guarnicion: 'Guarnición',
};

export function etiquetaTipo(tipo) {
  return TIPOS_ETIQUETA[tipo] || tipo || '';
}

export function lineasALista(texto) {
  return String(texto || '')
    .split('\n')
    .map((s) => s.replace(/^\s*(?:[-*•]|\d+[.)])\s+/, '').trim())
    .filter(Boolean);
}

export function idRecetaMiaDesdeQuery(query) {
  const raw = query && query.mia;
  const value = Array.isArray(raw) ? raw[0] : raw;
  if (value == null || String(value).trim() === '') return null;
  const n = parseInt(String(value), 10);
  return Number.isFinite(n) && n >= 1 ? String(n) : null;
}
